// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  invoiceManagement: {
    root: path(ROOTS_DASHBOARD, '/invoice'),
    following: path(ROOTS_DASHBOARD, '/invoice/following'),
    bill: path(ROOTS_DASHBOARD, '/invoice/bill'),
    po: path(ROOTS_DASHBOARD, '/invoice/po'),
    outsource: path(ROOTS_DASHBOARD, '/invoice/outsource'),
    newOutsource: path(ROOTS_DASHBOARD, '/invoice/newoutsource'),
    callingDaily: path(ROOTS_DASHBOARD, '/invoice/calling-daily'),
    buMessenger: path(ROOTS_DASHBOARD, '/invoice/bu-messenger'),
    email: path(ROOTS_DASHBOARD, '/invoice/e-mail'),
    ems: path(ROOTS_DASHBOARD, '/invoice/ems'),
    dailyfile: path(ROOTS_DASHBOARD, '/invoice/daily-file/:id'),
    planbill: path(ROOTS_DASHBOARD, '/invoice/plan-bill/:id'),
    calling: path(ROOTS_DASHBOARD, '/invoice/calling/:id'),
    customerSystem: path(ROOTS_DASHBOARD, '/invoice/customer-system')
  },
  master: {
    root: path(ROOTS_DASHBOARD, '/master'),
    configuration: path(ROOTS_DASHBOARD, '/master/configuration'),
    cutoffDocument: path(ROOTS_DASHBOARD, '/master/cutoff-document'),
    customerBehavior: path(ROOTS_DASHBOARD, '/master/customer-behavior'),
    riskCategory: path(ROOTS_DASHBOARD, '/master/risk-category'),
    creditRepGroup: path(ROOTS_DASHBOARD, '/master/bill-collector'),
    custCredGroup: path(ROOTS_DASHBOARD, '/master/payment-term'),
    customerBank: path(ROOTS_DASHBOARD, '/master/customer-bank'),
    paymentBank: path(ROOTS_DASHBOARD, '/master/payment-bank'),
    incommingGL: path(ROOTS_DASHBOARD, '/master/incomming-gl'),
    creditTeam: path(ROOTS_DASHBOARD, '/master/credit-team'),
    creditMapping: path(ROOTS_DASHBOARD, '/master/team-mapping'),
    tradeType: path(ROOTS_DASHBOARD, '/master/trade-type'),
    billMethod: path(ROOTS_DASHBOARD, '/master/bill-method'),
    paymentType: path(ROOTS_DASHBOARD, '/master/payment-type'),
    scgHoliday: path(ROOTS_DASHBOARD, '/master/scg-holiday'),
    bankHoliday: path(ROOTS_DASHBOARD, '/master/bank-holiday'),
    mainSalesEmp: path(ROOTS_DASHBOARD, '/master/main-sales-emp'),
    emailGroup: path(ROOTS_DASHBOARD, '/master/email-group'),
    configEmail: path(ROOTS_DASHBOARD, '/master/config-email'),
    mainSalesGroupSalesOffice: path(ROOTS_DASHBOARD, '/master/main-sales-group-sales-office'),
    selectInSelectOut: path(ROOTS_DASHBOARD, '/master/select-in-select-out'),
    insuranceCompany: path(ROOTS_DASHBOARD, '/master/insurance-company'),
    snapCreditMaster: path(ROOTS_DASHBOARD, '/master/snap-credit-master'),
    users: path(ROOTS_DASHBOARD, '/master/users'),
    role: path(ROOTS_DASHBOARD, '/master/role')
  },
  paymentManagement: {
    glStatemant: path(ROOTS_DASHBOARD, '/payment-management/gl-statemant'),
    followingPayment: path(ROOTS_DASHBOARD, '/payment-management/following-payment'),
    detailFollowingPayment: path(ROOTS_DASHBOARD, '/payment-management/detail-following-payment'),
    incomingPayment: path(ROOTS_DASHBOARD, '/payment-management/incoming-payment'),
    detailIncomingPayment: path(ROOTS_DASHBOARD, '/payment-management/detail-incoming-payment'),
    detailManullyMatching: path(ROOTS_DASHBOARD, '/payment-management/detail-manully-matching'),
    searchProblem: path(ROOTS_DASHBOARD, '/payment-management/search-problem'),
    detailSearchProblem: path(ROOTS_DASHBOARD, '/payment-management/detail-search-problem'),
    chequeReturn: path(ROOTS_DASHBOARD, '/payment-management/cheque-return')
  },
  workFlow: {
    root: path(ROOTS_DASHBOARD, '/work-flow'),
    lateCharge: path(ROOTS_DASHBOARD, '/work-flow/late-charge'),
    detailLateChargeCreate: path(ROOTS_DASHBOARD, '/work-flow/detail-late-charge-create'),
    detailLateChargeOther: path(ROOTS_DASHBOARD, '/work-flow/detail-late-charge-other'),
    postponeCheque: path(ROOTS_DASHBOARD, '/work-flow/postpone-cheque'),
    suspend: path(ROOTS_DASHBOARD, '/work-flow/suspend-list'),
    questionnaires: path(ROOTS_DASHBOARD, '/work-flow/questionnaires')
  },
  documentManagement: {
    root: path(ROOTS_DASHBOARD, '/document-management'),
    billingReceipt: path(ROOTS_DASHBOARD, '/document-management/billing-receipt'),
    documentInvoice: path(ROOTS_DASHBOARD, '/document-management/document-invoice'),
    ticketBE: path(ROOTS_DASHBOARD, '/document-management/ticket-be'),
    ticketDLC: path(ROOTS_DASHBOARD, '/document-management/ticket-dlc')
  },
  controlManagement: {
    root: path(ROOTS_DASHBOARD, '/control-management'),
    highlightOverdue: path(ROOTS_DASHBOARD, '/control-management/highlight-overdue')
  },
  riskManagement: {
    root: path(ROOTS_DASHBOARD, '/risk-management'),
    debenture: path(ROOTS_DASHBOARD, '/risk-management/debenture'),
    insurance: path(ROOTS_DASHBOARD, '/risk-management/insurance')
  },
  report: {
    root: path(ROOTS_DASHBOARD, '/report'),
    planCashInFlow: path(ROOTS_DASHBOARD, '/report/plan-cash-in-flow'),
    overdueReport: path(ROOTS_DASHBOARD, '/report/overdue-report'),
    monthlyReport: path(ROOTS_DASHBOARD, '/report/late-charge-report'),
    chequeReturnReport: path(ROOTS_DASHBOARD, '/report/cheque-return-report'),
    salesVolumeByCreditTerm: path(ROOTS_DASHBOARD, '/report/sales-volume-by-credit-term'),
    nonSap: path(ROOTS_DASHBOARD, '/report/non-sap'),
    kpiOverdue: path(ROOTS_DASHBOARD, '/report/kpi-overdue'),
    committee: path(ROOTS_DASHBOARD, '/report/committee')
  },
  exportPayment: {
    root: path(ROOTS_DASHBOARD, '/export-payment'),
    followingPaymentExport: path(ROOTS_DASHBOARD, '/export-payment/export-following-payment'),
    searchProblemExport: path(ROOTS_DASHBOARD, '/export-payment/export-search-problem'),
    overdueReportExport: path(ROOTS_DASHBOARD, '/export-payment/export-overdue-report'),
    detailSearchProblemExport: path(ROOTS_DASHBOARD, '/payment-management/export-detail-search-problem'),
    incomingPaymentExport: path(ROOTS_DASHBOARD, '/export-payment/export-incoming-payment'),
    creditAdvice: path(ROOTS_DASHBOARD, '/export-payment/export-credit-advice')
  }
};
